import { useEffect, useState } from 'react';

export const useDelayedLoading = (
  isLoading: boolean,
  delay = 400,
): boolean => {
  const [visible, setVisible] = useState(isLoading);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (isLoading) {
      setVisible(true);
    } else {
      timeoutId = setTimeout(() => {
        setVisible(false);
      }, delay);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isLoading, delay]);

  return visible;
};